import { render } from "./Package.vue?vue&type=template&id=5bfe72a0&scoped=true"
import script from "./Package.vue?vue&type=script&lang=js"
export * from "./Package.vue?vue&type=script&lang=js"

import "./Package.vue?vue&type=style&index=0&id=5bfe72a0&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfe72a0"]])

export default __exports__